import { http } from "../../config/HttpMethod";
import { JETLIFT_ENDPOINTS } from "../../store/jetlift/endpoints";
import { projectDetailsCalculationsPayload, saveProjectPayload } from "../../store/model/jetlift/jetlift";
import { MyProjects } from "../../models/Myprojects";
import { toLocalISOString } from "../../utilities/commonUtilities";
import { JetLiftMainReport } from "../../store/model/jetlift/jetliftMainreport";
import FileSaver from "file-saver";


export const getCalculations = async (payload: projectDetailsCalculationsPayload) => {
    try {
        const params = payload;
        const response = await http.get(`${JETLIFT_ENDPOINTS?.GET_PROJECT_DETAILS}`, { params });
        return response?.data
    } catch (err) {
        throw err;
    }
};

export const saveProject = async (payload: saveProjectPayload) => {
    const params = {
        Lifttype: payload?.Lifttype,
        projectID: payload?.projectID,
        showIPRPlotInMainReport: payload?.showIPRPlotInMainReport,
        tubingTab: payload?.tubingTab,
        wellInput: payload?.wellInput,
        fluidInput: payload?.fluidInput,
        jetPumpInput: payload?.jetPumpInput,
        othersInput: payload?.othersInput,
        ProjectData: payload?.ProjectData,
        WellSurveySamples: payload?.WellSurveySamples,
        WellSurveyESPAssembly: payload?.WellSurveyESPAssembly,
        ComparisonCaseId1: payload?.ComparisonCaseId1,
        ComparisonCaseId2: payload?.ComparisonCaseId2,
        ComparisonCaseId3: payload?.ComparisonCaseId3,
        AIEnabled: payload?.AIEnabled,
        CreatedOn: toLocalISOString(new Date()),
    };
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS?.SAVE_PROJECT}`, params);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
    }
};

export const createJetliftCase = async (payload: MyProjects) => {
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS?.CREATE_NEW_CASE}`, payload);
        return response?.data
    } catch (err) {
        console.log(err, 'error');
        throw err;
    }
};

export const deleteJetliftCase = async (payload: string) => {
    const params = {
        projectId: payload,
    };
    try {
        const response = await http.delete(`${JETLIFT_ENDPOINTS?.DELETE_CASE}`, { params });
        return response?.data
    } catch (err) {
        console.log(err, 'error');
        throw err;
    }
};

export const copyJetliftProject = async (params: {
    ProjectID: string;
    ProjectName: string;
    CaseName: string;
    DisplayCaseName: string;
    IsCaseLevel: boolean;
    customerCnxId: number;
    operatorContact: string;
    companyName: string;
    parentId: string;
    CaseProjectId: string;
}) => {
    try {
        const response = await http.get(`${JETLIFT_ENDPOINTS?.COPY_PROJECT}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err, 'error');
        throw err;
    }
};

export const SaveJetLiftMainReportData = async (reportData: JetLiftMainReport, projectId: string, unitSystem: string) => {
    const params = `projectId=${projectId}&unitSystem=${unitSystem}`;
    try {
        const response = await http.post(`${JETLIFT_ENDPOINTS?.SAVE_MAIN_REPORT_DATA}?${params}`, reportData);
        return response?.data
    } catch (err) {
        console.log(err, 'error jetlift main report');
    }
};

export const GetJetliftCaseComparisonData = async (caseId1: string, caseId2: string, caseId3: string) => {
    const params = {
        caseId1,
        caseId2,
        caseId3,
    };
    try {
        const response = await http.get(`${JETLIFT_ENDPOINTS?.GET_CASE_COMPARISON_DATA}`, { params });
        return response?.data
    } catch (err) {
        console.log(err, 'error jetlift case comparison');
    }
};

const getReportContentTypeAndFormat = (reportType: string) => {
    switch (reportType) {
        case "CSV":
            return { contentType: "text/csv", format: "csv" };
        case "RTF":
            return { contentType: "application/rtf", format: "rtf" };
        case "IMAGE":
            return { contentType: "image/tiff", format: "tiff" };
        default:
            return { contentType: "application/pdf", format: "pdf" };
    }
};

export const downloadJLMainReport = async (payload: Record<string, unknown>) => {
    try {
        const projectId = payload?.projectId ?? "";
        const reportType = (payload?.reportType as string) ?? "PDF";
        const { contentType, format } = getReportContentTypeAndFormat(reportType);
        const response = await http.post(
            `${JETLIFT_ENDPOINTS?.DOWNLOAD_JL_MAIN_REPORT}${reportType}?projectId=${encodeURIComponent(String(projectId))}`,
            payload,
            { responseType: "blob" }
        );
        const blob = new Blob([response.data], { type: contentType });
        const fileName = `${payload?.projectName}_JETLIFTReports.${format}`;
        FileSaver.saveAs(blob, fileName);
        return response?.data;
    } catch (err) {
        console.error("Error downloading JetLift main report:", err);
        throw err;
    }
};
